import { assoc, pipe } from 'ramda';
import {
  useListStudentEventsQuery,
  ListStudentEventsApiResponse,
} from '../../../services/generated/studentPortalApi';
import { useTimetableItems } from '@versita/frontend/timetable-hooks';

/**
 * Fetches student timetable, converts the events to the props expected by the
 * Timetable component and groups them by week day.
 */
export const useStudentEvents = pipe(useListStudentEventsQuery, (result) => {
  const { timetableItems, isFetchingEvents, isLoadingEvents } =
    useTimetableItems(assoc('data', result?.data?.events, result));
  return {
    timetableItems,
    isFetching: isFetchingEvents,
    isLoading: isLoadingEvents,
    timetable: result?.data
      ?.timetable as ListStudentEventsApiResponse['timetable'],
    registered: result?.data?.registered as boolean,
  };
});
